import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router';

const Reports = lazy(() => import('es/app/views/site/reports'));
const EditReport = lazy(() => import('es/app/views/site/reports/edit'));
const ReportAlerts = lazy(() => import('es/app/views/site/reports/edit/alerts'));
const ReportDefinition = lazy(() => import('es/app/views/site/reports/edit/definition'));
const ReportDefinitionExecutionLogGrid = lazy(
    () => import('es/app/views/site/reports/edit/history/ReportDefinitionExecutionLogGrid')
);
const ReportSchedules = lazy(() => import('es/app/views/site/reports/edit/schedules'));
const ReportSettings = lazy(() => import('es/app/views/site/reports/edit/settings'));
const ReportVariables = lazy(() => import('es/app/views/site/reports/edit/variables'));
const EditReportSchedule = lazy(() => import('es/app/views/site/reports/edit/schedules/edit/EditReportSchedule'));
const EditReportScheduleDefinition = lazy(
    () => import('es/app/views/site/reports/edit/schedules/edit/EditReportScheduleDefinition')
);
const ReportScheduleExecutionLogGrid = lazy(
    () => import('es/app/views/site/reports/edit/schedules/edit/ReportScheduleExecutionLogGrid')
);

export function ReportRoutes() {
    return (
        <Route path={siteMap.reports.search()} element={<Reports />} ErrorBoundary={RouteErrorBoundary}>
            <Route path={siteMap.reports.create()} element={<EditReport />}>
                <Route index element={<ReportDefinition />} />
            </Route>
            <Route path={siteMap.reports.edit().root} element={<EditReport />}>
                <Route index element={<ReportDefinition />} />
                <Route path={siteMap.reports.edit().variables} element={<ReportVariables />} />
                <Route path={siteMap.reports.edit().alerts} element={<ReportAlerts />} />
                <Route path={siteMap.reports.edit().schedules.root} element={<ReportSchedules />} />
                <Route path={siteMap.reports.edit().schedules.create} element={<EditReportSchedule />}>
                    <Route index element={<EditReportScheduleDefinition />} />
                </Route>
                <Route path={siteMap.reports.edit().schedules.edit().root} element={<EditReportSchedule />}>
                    <Route index element={<EditReportScheduleDefinition />} />
                    <Route
                        path={siteMap.reports.edit().schedules.edit().executionLog}
                        element={<ReportScheduleExecutionLogGrid />}
                    />
                </Route>
                <Route path={siteMap.reports.edit().customisation} element={<ReportSettings />} />
                <Route path={siteMap.reports.edit().history} element={<ReportDefinitionExecutionLogGrid />} />
            </Route>
        </Route>
    );
}
